// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import apiClient from "../config/api";
import { handleApiCall, buildParams } from "../utils/apiHelper";

/**
 * vhp_space CRUD against /admin/spaces/.
 *   GET    /admin/spaces/?scenario_id=1   list (paginated)
 *   GET    /admin/spaces/{space_id}       get single
 *   POST   /admin/spaces/                  create
 *   PUT    /admin/spaces/{space_id}        update
 *   DELETE /admin/spaces/{space_id}        delete
 */
const spaceService = {
  listSpaces: async ({
    scenarioId,
    locationId,
    spaceType,
    search,
    page,
    limit,
    includeInactive = false,
  } = {}) =>
    handleApiCall(
      () =>
        apiClient.get("/admin/spaces/", {
          params: buildParams({
            scenario_id: scenarioId,
            location_id: locationId,
            space_type: spaceType,
            search,
            page,
            limit,
            include_inactive: includeInactive,
          }),
        }),
      "Error fetching spaces",
    ),

  getSpaceById: async (spaceId) =>
    handleApiCall(
      () => apiClient.get(`/admin/spaces/${spaceId}`),
      `Error fetching space ${spaceId}`,
    ),

  createSpace: async (payload) =>
    handleApiCall(
      () => apiClient.post("/admin/spaces/", payload),
      "Error creating space",
    ),

  updateSpace: async (spaceId, payload) =>
    handleApiCall(
      () => apiClient.put(`/admin/spaces/${spaceId}`, payload),
      `Error updating space ${spaceId}`,
    ),

  deleteSpace: async (spaceId) =>
    handleApiCall(
      () => apiClient.delete(`/admin/spaces/${spaceId}`),
      `Error deleting space ${spaceId}`,
    ),
};

export default spaceService;
